import * as l from "react";
const e = (a) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 4a.5.5 0 00-.5.5V7h5V4.5a2.5 2.5 0 015 0 1 1 0 11-2 0 .5.5 0 10-1 0v9.989a.998.998 0 00.405-.26l.87-.917a1 1 0 011.451 1.376l-.87.917a3 3 0 01-3.533.613l-1.56-.79a1 1 0 00-1.017.066l-.895.613a3 3 0 01-3.218.109l-1.295-.763a1 1 0 00-1.006-.005l-1.248.718a3 3 0 01-3.433-.307l-1.296-1.095a1 1 0 111.29-1.528l1.296 1.095a1 1 0 001.145.102l1.248-.718A3 3 0 0110 13.552V4.5a2.5 2.5 0 015 0 1 1 0 11-2 0 .5.5 0 00-.5-.5zm-.5 6V9h5v1h-5zm0 2v2.619a1 1 0 00.721-.163l.895-.612a3 3 0 013.05-.2l.334.168V12h-5zm.721 6.956a1 1 0 01-1.072.037l-1.296-.763a3 3 0 00-3.02-.015l-1.247.718a1 1 0 01-1.145-.102l-1.296-1.095a1 1 0 10-1.29 1.528l1.296 1.095a3 3 0 003.433.307l1.248-.718a1 1 0 011.006.005l1.296.763a3 3 0 003.217-.11l.895-.612a1 1 0 011.016-.067l1.561.791a3 3 0 003.534-.613l.869-.917a1 1 0 00-1.452-1.376l-.87.918a1 1 0 01-1.177.204l-1.56-.79a3 3 0 00-3.051.2l-.895.612z",
      fill: "#2d6ded"
    }
  )
), t = e;
export {
  t as default
};
